export default class User {
  constructor() {
    this.id = "";
    this.name = "";

    this.results = [];
  }

  static validate(targetUser) {
    let result = {
      isInvalid: false,
      errors: []
    }

    let user = new Object()
    // for deep copy
    Object.assign(user, JSON.parse(JSON.stringify(targetUser)))

    if(!user.hasOwnProperty('id')) {
      result.isInvalid = true
      result.errors.push(new Error("user has not id"))
    }

    // dataがない場合終了
    if(!user.hasOwnProperty('data')) {
      result.isInvalid = true
      result.errors.push(new Error("user has not data"))
      return result
    }

    if(!user.data.hasOwnProperty('name')) {
      result.isInvalid = true
      result.errors.push(new Error("user has not name"))
    }

    return result
  }
}